.controls {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.sourceTrigger {
  min-width: 7.5rem;
}

.symbolForm {
  display: contents;
}

.symbolRoot {
  position: relative;
}

.symbolControl {
  display: flex;
  width: 11.25rem;
  align-items: stretch;
}

.symbolControl:hover,
.symbolControl:focus-within,
.symbolControl[data-expanded] {
  border-color: var(--color-accent);
}

.symbolInput {
  width: 100%;
  min-width: 0;
  padding-inline: var(--space-2-5) var(--space-1);
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--color-fg);
  font-family: var(--font-data);
  font-size: var(--text-sm);
  text-transform: uppercase;
}

.symbolInput::placeholder {
  color: var(--color-muted);
  text-transform: none;
}

.symbolTrigger {
  display: grid;
  flex: 0 0 var(--control-height-sm);
  place-items: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--color-muted);
  cursor: pointer;
}

.symbolTrigger:hover {
  color: var(--color-accent);
}

.symbolIcon {
  display: grid;
  place-items: center;
  transition: transform var(--duration-normal) var(--ease-out);
}

.symbolIcon[data-expanded] {
  transform: rotate(180deg);
}

.symbolIcon svg {
  width: 1em;
  height: 1em;
}

.symbolContent {
  width: min(22.5rem, var(--kb-popper-content-available-width));
  max-height: min(18.75rem, var(--kb-popper-content-available-height));
  transform-origin: var(--kb-combobox-content-transform-origin);
}

.symbolListbox {
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  outline: none;
}

.symbolItem {
  display: grid;
  grid-template-columns: minmax(6.25rem, 0.8fr) minmax(8.125rem, 1.2fr);
  min-height: 2rem;
  column-gap: var(--space-3);
}

.symbolTicker {
  color: #e2e8f0;
  font-family: var(--font-data);
  font-size: var(--text-xs);
}

.symbolEmpty {
  padding: var(--space-2);
  color: var(--color-muted);
  font-size: var(--text-xs);
}

.symbolLabel {
  overflow: hidden;
  color: var(--color-muted);
  font-size: var(--text-xs);
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 40rem) {
  .controls {
    width: 100%;
  }

  .symbolRoot {
    flex: 1;
    min-width: 0;
  }

  .symbolControl {
    width: 100%;
  }
}
